import { cn } from '@/shared/lib/utils'

interface LogoProps {
  className?: string
}

export function Logo({ className }: LogoProps) {
  return (
    <img
      src="/assets/img/logo.svg"
      alt="ASUS"
      className={cn('h-8 w-auto', className)}
    />
  )
}
